// extracted by mini-css-extract-plugin
export default {"container":"d6b838a7"};